// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { getIfAllMetricsAreFrozen } from '@components/custom-discounts/utils';
import { SPMLDMutationsContext } from '@streaming-projects/orgs/org-top-level/sp-custom-discounts/contexts/SPMLDMutationsContext';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridDeleteButton,
} from '@src/formik-utils/FieldArrayGrid';
import {
  IS_VBD,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_METRIC_ID_BACKEND_NAME,
} from '@src/constants';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';

const getIfMetricNameDeleteButtonShouldBeDisabled = (readOnlyMode, rowValues, formik) => {
  if (readOnlyMode) {
    return true;
  }

  if (rowValues.dimensions_config_array.length === 0) {
    return false;
  }

  if (!formik.isValid) {
    return true;
  }

  const dimensionConfigurationRowsForMetric = rowValues?.dimensions_config_array ?? [];
  const areAllDimensionConfigurationsOnlyVBDs = dimensionConfigurationRowsForMetric.every(
    (row) => row?.[IS_VBD] === true
  );

  // If all the dimension configurations are VBD only, then, return true to disable it
  if (areAllDimensionConfigurationsOnlyVBDs) {
    return true;
  }

  return !getIfAllMetricsAreFrozen(formik.values);
};

export const CommitMetricNameDeleteButtonContainer = () => {
  const formik = useFormikContext();
  const commitData = useContext(SPUserCommitDetailsContext);
  const {
    metricDiscountGroupDeleteMutation: [deleteMetricsDiscountGroup],
  } = useContext(SPMLDMutationsContext);
  const { orgId, commitId } = useParams();
  const { rowValues, readOnlyMode } = useContext(FieldArrayGridConfigItemContext);

  const payload = {
    commit_version: commitData?.version,
    metric_id: Number(rowValues[METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_METRIC_ID_BACKEND_NAME]),
  };

  const deleteMetricsLevelDiscountParams = {
    orgId: orgId,
    commitId: commitId,
    payload: payload,
  };

  return (
    <FieldArrayGridDeleteButton
      deleteFunc={deleteMetricsDiscountGroup}
      deleteFuncParams={deleteMetricsLevelDiscountParams}
      disabled={getIfMetricNameDeleteButtonShouldBeDisabled(readOnlyMode, rowValues, formik)}
      reloadPageAfterDelete={true}
    />
  );
};
